(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-directory"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('.store-directory');
    if (!section) return;

    const mapEl = document.getElementById('store-directory-map');
    if (!mapEl) return; // no locations, nothing to plot

    const apiKey = section.dataset.googleMapsApiKey;
    if (!apiKey) {
      mapEl.remove();
      return;
    }

    const dataEl = document.getElementById('store-directory-data');
    const stores = JSON.parse(dataEl.textContent)
      .map((store) => ({
        ...store,
        lat: store.lat !== null ? parseFloat(store.lat) : null,
        lng: store.lng !== null ? parseFloat(store.lng) : null,
      }))
      .filter((store) => store.lat !== null && store.lng !== null);

    if (!stores.length) {
      mapEl.remove();
      return;
    }

    // Build the info window body from DOM nodes so merchant-authored metaobject
    // values are inserted as text and never parsed as HTML.
    function buildInfoContent(store) {
      const content = document.createElement('div');
      content.className = 'store-directory__infowindow';

      const name = document.createElement('strong');
      name.textContent = store.name;

      const address = document.createElement('span');
      address.textContent = store.address1;

      const locality = document.createElement('span');
      locality.textContent = `${store.city}, ${store.state} ${store.zip}`;

      content.append(name, address, locality);
      return content;
    }

    window.initStoreDirectoryMap = function initStoreDirectoryMap() {
      const map = new google.maps.Map(mapEl, {
        center: { lat: 39.5, lng: -98.35 }, // continental US
        zoom: 4,
      });

      const bounds = new google.maps.LatLngBounds();
      stores.forEach((store) => {
        const marker = new google.maps.Marker({
          position: { lat: store.lat, lng: store.lng },
          map,
          title: store.name,
        });
        const infoWindow = new google.maps.InfoWindow({
          content: buildInfoContent(store),
        });
        marker.addListener('click', () => infoWindow.open(map, marker));
        bounds.extend({ lat: store.lat, lng: store.lng });
      });

      // Fit to every pin so the whole store list is visible at once.
      map.fitBounds(bounds, 40);
    };

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&callback=initStoreDirectoryMap`;
    script.async = true;
    // If the Maps API can't be reached (offline, blocked, or a bad key), remove
    // the empty map banner so it doesn't leave a blank box above the directory.
    script.onerror = () => mapEl.remove();
    document.head.appendChild(script);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-location"]) return;
  try {
    
  (function () {
    const mapEl = document.getElementById('store-location-map');
    if (!mapEl) return;

    const apiKey = mapEl.dataset.googleMapsApiKey;
    if (!apiKey) return;

    window.initStoreLocationMap = function initStoreLocationMap() {
      const lat = parseFloat(mapEl.dataset.lat);
      const lng = parseFloat(mapEl.dataset.lng);
      const map = new google.maps.Map(mapEl, {
        center: { lat, lng },
        zoom: 14,
      });
      new google.maps.Marker({
        position: { lat, lng },
        map,
        title: mapEl.dataset.title,
      });
    };

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&callback=initStoreLocationMap`;
    script.async = true;
    // If the Maps API can't be reached (offline, blocked, or a bad key), remove
    // the empty map banner so it doesn't leave a blank box above the details.
    script.onerror = () => mapEl.remove();
    document.head.appendChild(script);
  })();

  } catch(e) { console.error(e); }
})();
})();
